import { isEventLive } from 'models';

export const useIsLiveStatus = ({ startTime, endTime }: { startTime: Date; endTime: Date }) => {
  return isEventLive({ startTime, endTime });
};
